import { render } from "./ChainInformations.vue?vue&type=template&id=468434da"
import script from "./ChainInformations.vue?vue&type=script&lang=js"
export * from "./ChainInformations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__